<template>
  <div class="container">
    <a-card :bordered="false">
      <a-row type="flex" justify="space-between">
        <a-col
          :xs="24"
          :sm="24"
          :md="12"
          :lg="4"
          :xl="4"
          @click="toUserInfo(workInfo)"
          style="cursor: pointer"
        >
          <a-avatar
            shape="square"
            class="avatar"
            :size="40"
            :src="workInfo.avatar?workInfo.avatar_url:'/img/avatar.png'"
          />
          <span style="margin-left: 20px">{{
            workInfo.realname || workInfo.username
          }}</span>
        </a-col>
        <a-col :xs="24" :sm="24" :md="12" :lg="20" :xl="20">
          <div class="project-meta">
            <h2 class="title">{{ workInfo.workName }}</h2>
            <p class="time">发布于：{{ workInfo.createTime }}</p>
          </div>
        </a-col>
      </a-row>
      <a-row type="flex" justify="space-between">
        <a-col :xs="24" :sm="24" :md="24" :lg="workInfo.codeType==10?24:16" :xl="workInfo.codeType==10?24:16">
          <!-- 播放器 -->
          <div class="scratch-player">
            <iframe
              :src="getPlayerUrl(workInfo.codeType) + '&workId=' + workInfo.id"
              id="player"
              frameborder="0"
              width="100%"
              :scrolling="workInfo.codeType > 3 ? 'auto' : 'no'"
            ></iframe>
          </div>
          <keyboard v-if="_isMobile() && workInfo.codeType==2" :type="workInfo.keyboardType" @event="keyEvent"/>
        </a-col>
        <a-col v-show="workInfo.codeType!=10" :xs="24" :sm="24" :md="24" :lg="7" :xl="7">
          <div class="project-desc">
            <h2 class="title">作品简介</h2>
            <p v-html="workInfo.workDesc"></p>
            <h2 class="title">操作说明</h2>
            <p v-html="workInfo.playDesc"></p>
            <h2 class="title">标签</h2>
            <div class="catalog" v-if="workInfo.workTag">
              <div
                class="tag-wrap"
                v-for="(tag, index) in workInfo.workTag.split(',')"
                :key="index"
              >
                {{ tag }}
              </div>
            </div>
            <div class="btns" v-if="!_isMobile()">
              <span
                v-if="this.workInfo.editable"
              >
                <a
                  :href="
                    getEditorUrl(workInfo.codeType) +
                    '&scene=create&workId=' +
                    workInfo.id
                  "
                  target="_blank"
                  >查看代码</a
                >
              </span>
            </div>
          </div>
        </a-col>
      </a-row>
      <a-divider></a-divider>
      <div class="project-detail">
        <!-- 作品信息 -->
        <div class="project-info">
          <a-row type="flex">
            <a-col :span="24">
              <div class="project-op">
                <a-icon type="eye" />
                <span class="gap"> {{ workInfo.viewNum }}</span>

                <a-icon type="like" @click="starWork" />
                <span class="gap"> {{ workInfo.starNum }}</span>

                <a-icon
                  type="star"
                  :style="isCollect ? 'color:#ff9510' : 'color:#797979'"
                  @click="collectWork"
                />
                <span class="gap">
                  {{ workInfo.collectNum }}
                  {{ isCollect ? "已收藏" : "" }}</span
                >
                <span v-if="!_isMobile()">
                  <a-divider type="vertical"></a-divider>
                  <span class="gap">分享到</span>
                  <a-popover title="微信扫一扫手机体验和分享">
                    <template slot="content">
                      <qrcode
                        :value="getShareUrl()"
                        :size="200"
                        level="H"
                      ></qrcode>
                    </template>
                    <a-icon type="wechat" />
                  </a-popover>
                </span>
              </div>
            </a-col>
          </a-row>
        </div>
      </div>
    </a-card>
    <br />
    <a-card :bordered="false">
      <!-- 评论区 -->
      <div class="project-comment">
        <div class="publish">
          <a-row type="flex" justify="space-between">
            <a-col
              v-if="!_isMobile()"
              :xs="12"
              :sm="12"
              :md="4"
              :lg="4"
              :xl="4"
              class="comment-user"
            >
              <a-avatar
                shape="square"
                :size="60"
                icon="user"
                :src="avatarUrl"
              />
              <p>
                {{ token ? $store.state.user.info.realname : "未登录" }}
              </p>
            </a-col>
            <a-col :span="16" :xs="24" :sm="24" :md="16" :lg="16" :xl="16">
              <a-textarea
                v-model="commentContent"
                :rows="5"
                :maxLength="500"
                placeholder="说说这个作品怎么样吧"
              ></a-textarea>
            </a-col>
            <a-col :xs="24" :sm="24" :md="4" :lg="4" :xl="4">
              <div class="comment-btn">
                <a-button :disabled="!token" type="dashed" @click="comment"
                  >发表评论</a-button
                >
              </div>
            </a-col>
          </a-row>
        </div>
        <a-divider />
        <a-list
          class="comment-list"
          item-layout="horizontal"
          :locale="{ emptyText: '暂无评论' }"
          :data-source="comments"
        >
          <a-list-item slot="renderItem" slot-scope="item">
            <a-comment
              :author="item.nickname || item.realname || item.username"
            >
              <a-avatar
                shape="square"
                :size="40"
                slot="avatar"
                icon="user"
                :src="item.avatar"
              />
              <p class="comment-content" slot="content">
                {{ item.comment }}
              </p>
              <a-tooltip
                slot="datetime"
                :title="moment(item.createTime).format('YYYY-MM-DD HH:mm:ss')"
              >
                <span>{{ moment(item.createTime).fromNow() }}</span>
              </a-tooltip>
            </a-comment>
          </a-list-item>
          <div
            v-if="showLoadingMore"
            slot="loadMore"
            :style="{
              textAlign: 'center',
              marginTop: '12px',
              height: '32px',
              lineHeight: '32px',
            }"
          >
            <a-spin v-if="loadingMore" />
            <a-button type="link" v-else @click="workComments">
              加载更多
            </a-button>
          </div>
        </a-list>
      </div>
    </a-card>
  </div>
</template>

<script>
import Vue from "vue";
import { getAction, postAction } from "@/api/manage";
import { mapGetters } from "vuex";
import { ACCESS_TOKEN } from "@/store/mutation-types";
import QrCode from "@/components/tools/QrCode";
import moment from "moment";
import { mixinDevice } from "@/utils/mixin.js";
import {
  getEditorUrl,
  getPlayerUrl,
  getCodeIcon,
} from "@/utils/codeTypeUtil.js";
import Keyboard from '@/components/tools/Keyboard';

export default {
  name: "WorkDetail",
  mixins: [mixinDevice],
  components: {
    qrcode: QrCode,
    Keyboard
  },
  data() {
    return {
      workId: "",
      workInfo: {},
      token: "",
      commentContent: "",
      showLoadingMore: true,
      loadingMore: false,
      commentsPage: 0,
      comments: [],
      isCollect: false,
    };
  },
  computed: {
    avatarUrl() {
      if (this.$store.state.user.info && this.$store.state.user.info.avatar) {
        return this.$store.state.user.info.avatar;
      } else {
        return "/img/avatar.png";
      }
    },
  },
  created() {
    this.workId = this.$route.query.workId;
    this.getWorkInfo(this.workId);
    this.token = Vue.ls.get(ACCESS_TOKEN);
  },
  mounted() {
    var that = this;
    //scratch全屏
    document.addEventListener("scratchFullScreen", function (e) {
      console.log("fullscreen");
      that.launchIntoFullscreen(document.getElementById("player"));
    });
    //scratch退出全屏
    document.addEventListener("scratchUnFullScreen", function (e) {
      that.exitFullscreen();
    });
    document.addEventListener("scratchInit", function (e) {
      var p = document.getElementById("player");
      var s = p.contentDocument.getElementById("scratch");
      s.addEventListener("click", () => {
        p.focus();
      });
    });
    
  },
  methods: {
    ...mapGetters(["nickname", "avatar", "userInfo"]),
    moment,
    getEditorUrl,
    getPlayerUrl,
    getCodeIcon,
    keyEvent(key, keyCode, isDown){
      let player = document.getElementById("player");
      player.contentWindow.vm.postIOData("keyboard", {
        keyCode: keyCode,
        key: key,
        isDown: isDown,
      });
    },
    getWorkInfo(workId) {
      getAction("/teaching/teachingWork/studentWorkInfo?workId=" + workId).then(
        (res) => {
          if (res.success) {
            this.workInfo = res.result;
            this.calcPlayerHeight(this.workInfo.codeType)
            this.workComments();
          } else {
            this.$message.error("作品获取失败");
          }
        }
      );
    },
    //计算播放器高度
    calcPlayerHeight(codeType){
      let playerDom = document.getElementById("player");
      if(codeType == 1 || codeType == 2){
        playerDom.style.height = playerDom.clientWidth * 0.9 + "px";
      }else{
        playerDom.style.height = "600px";
      }
    },
    starWork() {
      getAction("/teaching/teachingWork/starWork?workId=" + this.workId).then(
        (res) => {
          if (res.success) {
            if (res.message == "点赞成功") {
              this.workInfo.starNum += 1;
            }
            this.$message.success(res.message);
          }
        }
      );
    },
    collectWork() {
      getAction(
        "/teaching/teachingWork/collectWork?workId=" + this.workId
      ).then((res) => {
        if (res.success) {
          if (res.message == "收藏成功") {
            this.isCollect = true;
            this.workInfo.collectNum += 1;
          } else {
            this.isCollect = false;
            this.workInfo.collectNum -= 1;
          }
          this.$message.success(res.message);
        }
      });
    },
    isCollectWork() {
      getAction(
        "/teaching/teachingWork/isCollectWork?workId=" + this.workId
      ).then((res) => {
        this.isCollect = res.success;
      });
    },
    workComments() {
      if(!this.$store.state.user.info){
        return
      }
      this.commentsPage += 1;
      this.loadingMore = true;
      getAction("/teaching/comment/queryCommentBySourceId", {
        id: this.workId,
        page: this.commentsPage,
      }).then((res) => {
        this.loadingMore = false;
        if (res.result.length == 0 && this.commentsPage > 1) {
          this.$message.info("已加载完啦！");
        } else {
          this.comments = this.comments.concat(res.result);
        }
      });
    },
    comment() {
      if (this.commentContent != "") {
        postAction("/teaching/comment/saveComment", {
          sourceType: '1',
          sourceId: this.workId,
          comment: this.commentContent,
        }).then((res) => {
          if (res.success) {
            this.comments.unshift({
              comment: this.commentContent,
              realname: this.$store.state.user.info.realname,
              avatar: this.avatarUrl,
              createTime: new Date(),
            });
            this.commentContent = "";
            this.$message.success(res.message);
          }
        });
      }
    },
    getShareUrl() {
      // return (
      //   window.location.protocol +
      //   "//" +
      //   window.location.host +
      //   "/scratch3/scratch-mobile?workId=" +
      //   this.workId
      // );
      return window.location.href;
    },
    enter() {
      this.$router.push("/account/center");
    },
    toUserInfo(info) {
      this.$router.push("/friend/detail?id=" + info.userId);
    },
    launchIntoFullscreen(element) {
      if (element.requestFullscreen) {
        element.requestFullscreen();
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen();
      } else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullscreen();
      } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen();
      }
    },
    exitFullscreen() {
      if (window.document.exitFullscreen) {
        window.document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        window.document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        window.document.webkitExitFullscreen();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  background: url(/img/bg_blue.png) no-repeat;
  background-color: #f6f6f6;
  background-size: 100% 250px;
}

.scratch-player {
  margin: auto;
  iframe {
    // max-width: 720px;
    max-height: 600px;
  }
}
.project-desc {
  .title {
    position: relative;
    margin-bottom: 12px;
    font-size: 15px;
    color: #333;
    font-weight: bold;
  }
  .catalog {
    color: #027db4;
    .tag-wrap {
      display: inline;
      border-radius: 50px;
      background: #f2f2f2;
      margin: 0 10px;
      padding: 5px 10px;
      font-size: 14px;
    }
    span {
      vertical-align: middle;
      margin-right: 50px;
    }
  }
  .btns {
    margin-top: 30px;
    span {
      display: inline-block;
      width: 144px;
      height: 50px;
      line-height: 50px;
      border-radius: 50px;
      text-align: center;

      font-size: 20px;
      background: rgba(245, 154, 35, 1);
      &:first-child {
        margin-right: 60px;
      }
    }
    a {
      color: #fff;
    }
  }
}

.project-detail {
  width: 100%;

  .project-info {
    padding: 10px;
    .project-meta {
      text-align: left;
    }
    .project-op {
      color: #797979;
      .anticon {
        font-size: 28px;
      }
      .gap {
        margin-right: 20px;
        font-size: 24px;
      }
    }
  }
}
.project-comment {
  padding: 10px;
  .publish {
    .comment-user {
      text-align: center;
      padding-top: 20px;
    }
    .comment-btn {
      text-align: center;
      padding-top: 10px;
      button {
        height: 80px;
      }
    }
  }
  .comment-list {
    color: #999;
    border: 1px solid #e9e9e9;
    border-top: none;
    padding: 0 20px;
    .comment-content {
      // width: 600px;
    }
    .item {
      padding: 20px;
      font-size: 13px;
      border-bottom: 1px solid #e9e9e9;

      .people {
        font-size: 30px;
      }
      .user {
        color: #666;
        font-size: 14px;
        margin-right: 5px;
      }
      .time {
        font-size: 12px;
      }
      span {
        margin-right: 30px;
      }
      p {
        margin: 10px 0;
      }
    }
    .more {
      font-size: 13px;
      text-align: center;
      padding-top: 40px;
      padding-bottom: 20px;
      > span {
        border: 1px solid #e9e9e9;
        line-height: 47px;
        width: 140px;
        height: 47px;
        display: inline-block;
        color: #999;
      }
    }
  }
}
</style>